import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  leftIcon?: ReactNode
  rightIcon?: ReactNode
}

const Input = forwardRef<HTMLInputElement, Props>(
  ({ leftIcon, rightIcon, className = '', style, ...props }, ref) => {
    return (
      <div
        className={`flex items-center gap-sp-2 rounded-md ${className}`}
        style={{
          backgroundColor: 'var(--tg-theme-secondary-bg-color)',
          height: '44px',
          paddingLeft: 'var(--space-3)',
          paddingRight: 'var(--space-3)',
          ...style,
        }}
      >
        {leftIcon && (
          <span className="shrink-0" style={{ color: 'var(--tg-theme-hint-color)' }}>
            {leftIcon}
          </span>
        )}
        <input
          ref={ref}
          className="flex-1 bg-transparent outline-none text-base min-w-0"
          style={{
            color: 'var(--tg-theme-text-color)',
            caretColor: 'var(--tg-theme-accent-text-color)',
          }}
          {...props}
        />
        {rightIcon && (
          <span className="shrink-0" style={{ color: 'var(--tg-theme-hint-color)' }}>
            {rightIcon}
          </span>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'

export default Input
